<script>
const OPEN_MODEL_COUNTER_VALUE = 2;
import Subscribe from "@/components/Subscribe";
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: "SubscribePopup2",
    components: { Subscribe },
    data() {
        return {
            email: "",
            isValid: true,
            isOpen: false,
            timeout: null,
        };
    },
    computed: {
        ...mapState("popups", ["isShowSubscribePopup2"]),
        ...mapGetters("globalvars", ["getUserHasOrders"]),
        content() {
            /* return {
                image: {
                    d: "/img/popup/cover-black-friday.jpg",
                    m: "/img/popup/cover-black-friday-m.jpg",
                },
                text: this.$t("subscribe_popup_text_black_friday"),
                target: "promo5",
                buttonText: this.$t("subscribe_popup_text_black_friday_button"),
                emailPlaceholder: this.$t("subscribe_popup_text_black_friday_email_placeholder"),
                subscribeFormClass: "black-friday-subscribe",
            };
*/

            // return {
            //     image: {
            //         d: "/img/popup/cover-2.jpg",
            //         m: "/img/popup/cover-2m.jpg",
            //     },
            //     text: this.$t("subscribe_popup_text"),
            //     target: "welcome_promo",
            //     buttonText: "",
            //     emailPlaceholder: "",
            //     subscribeFormClass: "black-friday-subscribe",
            // };
            return {
                image: {
                    d: "/img/popup/cover-4.jpg",
                    m: null,
                },
                text: "",
                preTextHTML: `
                    <div class="tac text_red">
                        <div class="text_80">-15%</div>
                        <div class="text_30">${this.$t("for_your_first_order")}</div>
                    </div>
                `,
                target: "",
                buttonText: "",
                emailPlaceholder: "",
                subscribeFormClass: "",
            };
        },
    },
    watch: {
        $route() {
            this.show();
        },
    },
    methods: {
        ...mapMutations("popups", ["toggleIsShowSubscribePopup2"]),

        close() {
            this.isOpen = false;
            this.toggleIsShowSubscribePopup2(false);
        },
        show() {
            // если у пользователя небыло заказов
            if (!this.getUserHasOrders) {
                let counter = sessionStorage.getItem("subscribePopup2_counter") || 0;

                // Увеличиваем счетчик
                counter = parseInt(counter) + 1;
                console.log(`show =>`, counter);
                sessionStorage.setItem("subscribePopup2_counter", counter);

                // Если достигли нужного количества переходов И таймер еще не запущен
                const isShowed = sessionStorage.getItem("subscribePopup2_showed", 1);
                if (counter >= OPEN_MODEL_COUNTER_VALUE && !isShowed) {
                    setTimeout(() => {
                        this.isOpen = true;
                        this.$grom.reachGoal("subscrbe-popup-show");

                        sessionStorage.setItem("subscribePopup2_showed", 1);
                    }, 2000);
                }
            }
        },
    },
    mounted() {
        console.log(`test-subscribe-modal`);
        this.$nuxt.$on("test-subscribe-modal", this.show);
    },
};
</script>

<template>
    <!-- popup--fullscreen для полноэкранных модалок, просто popup в уголке будет висеть -->
    <div class="popup popup--fullscreen" v-if="isOpen" v-bsl="!$device.isDesktop && isOpen">
        <div class="popup__close" @click="close"></div>
        <div class="popup__content">
            <div class="popup-image">
                <picture>
                    <source media="(max-width: 750px)" v-lazy-load :data-srcset="content.image.m" />
                    <source media="(min-width: 751px)" v-lazy-load :data-srcset="content.image.d" />
                    <img v-lazy-load :data-src="content.image.d" alt="" />
                </picture>
            </div>
            <div class="popup-content">
                <div class="close-text-container">
                    <div @click="close" class="close-text">{{ $t("close") }}</div>
                </div>

                <div class="popup-content-grow">
                    <div v-if="content.preTextHTML" class="popup-html-content" v-html="content.preTextHTML"></div>
                    <div v-if="content.text" class="description">
                        {{ content.text }}
                    </div>
                    <Subscribe
                        hideLabel
                        showSubmit
                        button-class="subscribe-button"
                        :button-text="content.buttonText"
                        :subscribe-form-class="content.subscribeFormClass"
                        :email-placeholder="content.emailPlaceholder"
                        :target="content.target" />
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="less">
.popup {
    position: fixed;
    right: 24px;
    bottom: 24px;
    width: 95%;
    max-height: calc(100dvh - 48px);
    border: 1px solid @text_1;
    z-index: 150;
    box-shadow: 0px 0px 84px 0px rgba(0, 0, 0, 0.12);
    font-family: "Arial", sans-serif;

    .popup-html-content {
        padding-bottom: 32px;
        margin-top: auto;
        margin-bottom: auto;
        @media @sm {
            padding-bottom: 13px;
        }
    }
    &__content {
        max-width: calc(100% - 40px);
        width: 780px;
        display: flex;
        background: #fff;
        position: relative;
        z-index: 2;
    }
    &__close {
        position: absolute;
        inset: 0;
        z-index: 1;
        background: #00000044;
    }

    @media @sm {
        flex-direction: column-reverse;
        justify-content: start;
        width: 100%;
        right: 0;
        bottom: 0;
        max-height: initial;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        height: 100%;
        height: 100dvh;
    }

    &-image {
        width: 60%;
        border-right: 1px solid @text_1;
        @media @sm {
            width: 100%;
            height: 100%;
            border-right: none;
            border-top: 1px solid @text_1;
        }
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: top;
            display: block;
        }
    }

    &-content {
        width: 40%;
        padding: 20px 24px 40px 24px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        overflow-y: auto;

        @media @sm {
            width: 100%;
            padding: 20px 26px 30px 25px;
            overflow: visible;
        }

        .close-text-container {
            text-align: right;
            margin-bottom: 40px;

            @media @sm {
                margin-bottom: 45px;
            }
        }

        .close-text {
            color: #000000;
            cursor: pointer;
            display: inline-block;
            padding-bottom: 1px;
            border-bottom: 1px solid #000000;
            font-weight: 400;
            font-size: 15px;
            line-height: 140%;
            letter-spacing: 2.4px;
            @media @sm {
                font-size: 14px;
            }
        }

        .description {
            font-weight: 400;
            font-size: 15px;
            line-height: 140%;
            letter-spacing: 2.4px;
            margin-bottom: 20px;
            color: #000;
            br {
                display: none;
            }
            @media @sm {
                font-size: 14px;
                letter-spacing: 2.24px;
                br {
                    display: unset;
                }
            }
        }
    }
    &--fullscreen {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 0;
        max-height: 100%;
        max-width: 100%;
        right: 0;
        bottom: 0;
        left: 0;
        top: 0;

        .close-text-container {
            margin-bottom: 14px;
        }
        .popup-image {
            width: 50%;
            border-right: 0;
            @media @sm {
                display: none;
            }
        }
        .popup-content {
            width: 50%;
            padding: 19px 31px 39px 31px;
            @media @sm {
                width: 100%;
            }
        }
        .popup-content-grow {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
        }
        .popup-html-content {
            margin-bottom: 0;
            margin-top: 0;
        }
    }
}
</style>
<style lang="less">
.popup {
    .text_red {
        color: #e62c39;
    }
    .text_80 {
        font-size: 80px;
        font-weight: 900;
        font-family: "HelveticaNeue";
        letter-spacing: -1px;
    }
    .text_30 {
        font-size: 30px;
        font-family: "HelveticaNeue";
    }
}
.popup.popup--fullscreen {
    .subscribe {
        .form-group__input {
            height: 50px;
            font-family: "HelveticaNeue";
        }

        .subscribe__submit {
            margin-top: 17px;
            border-radius: 0;
            font-family: "HelveticaNeue";
            text-align: center;
        }
    }
}
.subscribe-button {
    height: 50px;
    width: 100%;
    background-color: #ff002a;
    opacity: 1 !important;
    color: #ffffff;
    border: none;
    border-radius: 2.26px;
    font-size: 17px;
    line-height: 144%;
    letter-spacing: 2.72px;
    &:hover {
        background-color: #000;
    }
}
</style>
